import { render, staticRenderFns } from "./suContractDetail.vue?vue&type=template&id=7ec01dd1"
import script from "./suContractDetail.vue?vue&type=script&lang=js"
export * from "./suContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports